import _map from 'lodash/map';

import initialState from './initialState';
import actionTypes from './actionTypes';

const validationConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_VALIDATIONS_BY_GROUP_SUCCESS:
            return {
                ...state,
                validationsByGroup: action.payload,
            };
        case actionTypes.GET_EVENT_PROCESSES:
            return {
                ...state,
                refDataEventProcess: action.payload,
            };
        case actionTypes.GET_EVENT_PROCESSES_ORDER:
            return {
                ...state,
                refDataEventProcessOrders: action.payload,
            };
        case actionTypes.GET_REF_DATA_EVENT_MONITORING_DATA: {
            return {
                ...state,
                rowData: action.payload.records,
                gridOptions: {
                    ...state.gridOptions,
                    columnDefs: action.payload.columns,
                },
            };
        }
        default:
            return state;
    }
};

export default validationConfigurationReducer;
